import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Button from '@saucelabs/sl-component-buttons';
import modalConnect from '@saucelabs/sl-container-modal';
import { Modal } from '@saucelabs/sl-component-overlay';

const name = 'removeTeamsFromGroup';
class RemoveTeamsFromGroupModal extends Component {
  shouldComponentUpdate(nextProps) {
    const { show } = this.props;
    return show !== nextProps.show || nextProps.show;
  }

  submit(payload) {
    const { handleSubmit, onHide } = this.props;
    handleSubmit(payload).then(onHide);
  }

  render() {
    const { onHide, selectedTeams, show, teams } = this.props;

    const teamsToRemove = teams
      .filter((team) => selectedTeams.includes(team.id))
      .toArray();

    return (
      <Modal
        onHide={onHide}
        show={show}
      >
        <Modal.Header>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <b>Are you sure you wish to remove the following teams from the line of business?</b>
          <p>The team won&apos;t be deleted from your organization.</p>
          <ul>
            {teamsToRemove.map((team) => (
              <li key={team.id}>{team.name}</li>
            ))}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button
            category="default"
            material
            onClick={onHide}
            size="sm"
          >
            Cancel
          </Button>
          <Button
            category="danger"
            material
            name={name}
            onClick={() => this.submit(selectedTeams)}
            size="sm"
          >
            Yes, Remove
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

RemoveTeamsFromGroupModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  selectedTeams: ImmutablePropTypes.set.isRequired,
  show: PropTypes.bool.isRequired,
  teams: ImmutablePropTypes.list.isRequired,
};

export default modalConnect(name, RemoveTeamsFromGroupModal);
export { name, RemoveTeamsFromGroupModal };
